import { PublicClientApplication, type Configuration, LogLevel } from '@azure/msal-browser';
import { ENTRA_CLIENT_ID, ENTRA_API_SCOPES } from '@cade/shared-types';

export const msalConfig: Configuration = {
  auth: {
    clientId: ENTRA_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginScopes = ENTRA_API_SCOPES;

let _msalInstance: PublicClientApplication | null = null;

export function getMsalInstance(): PublicClientApplication | null {
  if (!ENTRA_CLIENT_ID) return null;
  if (!_msalInstance) {
    _msalInstance = new PublicClientApplication(msalConfig);
  }
  return _msalInstance;
}

export function isSsoConfigured(): boolean {
  return !!ENTRA_CLIENT_ID;
}

// Eagerly kick off MSAL initialization + redirect handling at module load.
// This ensures handleRedirectPromise() is called exactly once, regardless of
// React StrictMode double-mounting.
import type { AuthenticationResult } from '@azure/msal-browser';

let _redirectPromise: Promise<AuthenticationResult | null> | null = null;

export function getMsalRedirectResult(): Promise<AuthenticationResult | null> | null {
  if (_redirectPromise) return _redirectPromise;
  const msal = getMsalInstance();
  if (!msal) return null;
  _redirectPromise = msal.initialize().then(() => msal.handleRedirectPromise());
  return _redirectPromise;
}
